// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"89473a31","29":"d33c4356","44":"d7d5272b","291":"9f272cc9","496":"06b40e7e","680":"34615cee","939":"3b9380f3"}[chunkId] + ".chunk.js";
};